import { faFileContract } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper, DetailInfo, DetailRow } from '@labrav/common'
import { ButtonV2, VerticalDivider } from '@labrav/react-components'
import { useStyles } from '../ViewDetailsResellerAuthorization.styles'
import type { ViewResellerAuthorizationType } from '../../../../modules/receivedResellerAuthorization/types'
import { isEmpty } from 'lodash'

export const ViewResellerAuthorizationEula = ({
  resellerAuthorization,
}: {
  resellerAuthorization: ViewResellerAuthorizationType
}) => {
  const { classes } = useStyles()
  const openEula = (eulaFiles?: string[]) => () => {
    if (!isEmpty(eulaFiles)) {
      eulaFiles?.forEach(file => {
        const newWind = window.open(file, '_blank', 'noopener noreferrer')
        if (newWind) {
          newWind.opener = null
        }
      })
    }
  }

  return (
    <>
      <SectionWrapper
        heading="EULA details"
        icon={faFileContract}
        children={
          <div className={classes.section}>
            <DetailRow
              borderBottom={false}
              children={
                <>
                  <DetailInfo
                    title={'Reseller EULA'}
                    keyName="endCustomerEulaType"
                    value={
                      <div className={classes.customWrapper}>
                        {resellerAuthorization?.endCustomerEulaType}{' '}
                        {resellerAuthorization?.endCustomerEulaFiles &&
                          !!resellerAuthorization?.endCustomerEulaFiles
                            ?.length && (
                            <>
                              <VerticalDivider height="24px" />
                              <ButtonV2
                                styleType="link"
                                onClick={openEula(
                                  resellerAuthorization?.endCustomerEulaFiles
                                )}
                              >
                                View EULA
                              </ButtonV2>
                            </>
                          )}
                      </div>
                    }
                  />
                  {resellerAuthorization?.resellerLicenseAgreementType && (
                    <DetailInfo
                      title={'End buyer EULA'}
                      keyName="resellerLicenseAgreementType"
                      value={
                        <div className={classes.customWrapper}>
                          {resellerAuthorization?.resellerLicenseAgreementType?.toUpperCase()}{' '}
                          {resellerAuthorization?.resellerLicenseAgreementFiles &&
                            !!resellerAuthorization
                              ?.resellerLicenseAgreementFiles?.length && (
                              <>
                                <VerticalDivider height="24px" />
                                <ButtonV2
                                  styleType="link"
                                  onClick={openEula(
                                    resellerAuthorization?.resellerLicenseAgreementFiles
                                  )}
                                >
                                  View EULA
                                </ButtonV2>
                              </>
                            )}
                        </div>
                      }
                    />
                  )}
                </>
              }
            />
          </div>
        }
      />
    </>
  )
}
